import React from "react";
import { Typography, Box } from "@mui/material";

const Settings = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h4">Configuración</Typography>
    <Typography variant="body1">Aquí puedes cambiar las configuraciones del sistema.</Typography>
  </Box>
);

export default Settings;
